module.exports = __webpack_public_path__ + "assets/img/tech-15.f27add64.svg";